import {
  HIDE_ADD_TARGET_MODAL,
  HIDE_FAULTY_SENSOR_MODAL,
  IHideAddTargetModal,
  IHideFaultySensorModal,
  IShowAddTargetModal,
  IShowFaultySensorModal,
  SHOW_ADD_TARGET_MODAL,
  SHOW_FAULTY_SENSOR_MODAL
} from "./types";

export const showFaultySensorModal = (pressureChambers: number[]): IShowFaultySensorModal => ({
  type: SHOW_FAULTY_SENSOR_MODAL,
  payload: pressureChambers
});

export const hideFaultySensorModal = (): IHideFaultySensorModal => ({
  type: HIDE_FAULTY_SENSOR_MODAL
});

export const showAddTargetModal = (): IShowAddTargetModal => ({
  type: SHOW_ADD_TARGET_MODAL
});

export const hideAddTargetModal = (): IHideAddTargetModal => ({
  type: HIDE_ADD_TARGET_MODAL
});
